// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
import { db } from '@/shared/firebase/firebase-init';
const KEY_ACTIVITIES = 'userActivity'
const SIZE = 10;

export default {
  size: 10,

  fetch(userId, lastmodified) {
    return new Promise((resolve) => {
      db.ref(KEY_ACTIVITIES)
        .child(userId)
        .orderByChild("modified")
        .endAt(lastmodified-1)
        .limitToLast(SIZE)
        .once('value').then((snapshot) => { 
          var list = []
          snapshot.forEach(childSnapshot => {
            list.push(childSnapshot.val())
          });
          
          const result =  {
            data: list.reverse(),
            last: list.length < SIZE
          }

        resolve(result)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/activity/activity-service.js